import styled from 'styled-components';

export const BaseLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 100vh;

  @media print {
    min-height: unset;
  }
`;
